import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DataTablesModule } from 'angular-datatables';
import { TagCloudModule } from 'angular-tag-cloud-module';
import { ChecklistItemHistoriesComponent } from 'app/_components/checklist-item-histories/checklist-item-histories.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MarkdownModule } from 'ngx-markdown';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AiChatFiltersComponent } from '../_components/ai-chat/ai-chat-filters/ai-chat-filters.component';
import { AiChatComponent } from '../_components/ai-chat/ai-chat.component';
import { AvatarInitialsComponent } from '../_components/avatar-initials/avatar-initials.component';
import { BarAndLineChartComponent } from '../_components/bar-and-line-chart/bar-and-line-chart.component';
import { BarSeriesVerticalComponent } from '../_components/bar-and-line-chart/bar-series-vertical.component';
import { BarChartWithPaginationComponent } from '../_components/bar-chart-with-pagination/bar-chart-with-pagination.component';
import { CardComponent } from '../_components/card/card.component';
import { CheckableCardComponent } from '../_components/checkable-card/checkable-card.component';
import { ChecklistItemGroupComponent } from '../_components/checklist-item-group/checklist-item-group.component';
import { ChecklistItemsModalComponent } from '../_components/checklist-items-modal/checklist-items-modal.component';
import { ClpAudioPlayerComponent } from '../_components/clp-audio-player/clp-audio-player.component';
import { TimeFormatPipe } from '../_components/clp-audio-player/time-format.pipe';
import { ConfirmDangerDialogComponent } from '../_components/confirm-danger-dialog/confirm-danger-dialog.component';
import { ConfirmDialogComponent } from '../_components/confirm-dialog/confirm-dialog.component';
import { RejectAiDecisionModalComponent } from '../_components/reject-ai-decision-modal/reject-ai-decision-modal.component';
import { ConfirmMonitorComponent } from '../_components/confirm-monitor/confirm-monitor.component';
import { ContestationAiPreviewModalComponent } from '../_components/contestation-ai-preview-modal/contestation-ai-preview-modal.component';
import { DataTableComponent } from '../_components/data-table/data-table.component';
import { DiasUteisComponent } from '../_components/dias-uteis/dias-uteis.component';
import { EvoDndDirective } from '../_components/dragndrop/drag-drop.directive';
import { EvoCardExpandComponent } from '../_components/evo-card-expand/evo-card-expand.component';
import { EvoStepperComponent } from '../_components/evo-stepper/evo-stepper.component';
import { AgentFilterComponent } from '../_components/filter/agent/agent-filter.component';
import { FilterComponent } from '../_components/filter/filter.component';
import { GradeComponent } from '../_components/filter/grade/grade.component';
import { MonitorFilterComponent } from '../_components/filter/monitor/monitor-filter.component';
import { HelpDialogComponent } from '../_components/help-dialog/help-dialog.component';
import { IndicatorsComponent } from '../_components/indicators/indicators.component';
import { InlineEditInputComponent } from '../_components/inline-edit-input/inline-edit-input.component';
import { InlineVideoPlayerComponent } from '../_components/inline-video-player/inline-video-player.component';
import { InputDialogComponent } from '../_components/input-dialog/input-dialog.component';
import { InteractionAttachmentDialogComponent } from '../_components/interaction-attachment-dialog/interaction-attachment-dialog.component';
import { InteractionCommentModalComponent } from '../_components/interaction-comment-modal/interaction-comment-modal.component';
import { InteractionCommentsComponent } from '../_components/interaction-comments/interaction-comments.component';
import { InteractionModalComponent } from '../_components/interaction-modal/interaction-modal.component';
import { ItemCheckComponent } from '../_components/item-check/item-check.component';
import { JustificationInlineFormComponent } from '../_components/justification-selector-modal/justification-inline-form/justification-inline-form.component';
import { JustificationSelectorModalComponent } from '../_components/justification-selector-modal/justification-selector-modal.component';
import { LegendIndicatorComponent } from '../_components/legend-indicator/legend-indicator.component';
import { ModalComponent } from '../_components/modal/custom-modal.component';
import { MoreActionsButtonComponent } from '../_components/more-actions-button/more-actions-button.component';
import { OnboardOverlayComponent } from '../_components/onboard-overlay/onboard-overlay.component';
import { OnlyPremiumDialogComponent } from '../_components/only-premium-dialog/only-premium-dialog.component';
import { OperationAddDialogComponent } from '../_components/operation-add-dialog/operation-add-dialog.component';
import { RangeDatepickerComponent } from '../_components/range-datepicker/range-datepicker.component';
import { RangeSliderComponent } from '../_components/range-slider/range-slider/range-slider.component';
import { SearchInputComponent } from '../_components/search-input/search-input.component';
import { SelectComponent } from '../_components/select/select.component';
import { SimpleCheckableCardComponent } from '../_components/simple-checkable-card/simple-checkable-card.component';
import { SpeedTestComponent } from '../_components/speed-test/speed-test.component';
import { StatusBadgeComponent } from '../_components/status-badge/evo-status-badge.component';
import { StepperFooterComponent } from '../_components/stepper-footer/stepper-footer.component';
import { StepperHeaderComponent } from '../_components/stepper-header/stepper-header.component';
import { StandardFooterButtonsComponent } from '../_components/standard-footer-buttons/standard-footer-buttons.component';
import {
  CurrentStepDirective,
  StepperModalComponent,
} from '../_components/stepper-modal/stepper-modal.component';
import { StepperTitleComponent } from '../_components/stepper-title/stepper-title.component';
import { TimelineListComponent } from '../_components/timeline-list/timeline-list.component';
import { ToastComponent } from '../_components/toast/toast.component';
import { TrainingErrorDialogComponent } from '../_components/training-error-dialog/training-error-dialog.component';
import { UploadFileComponent } from '../_components/upload-file/upload-file.component';
import { UserCardComponent } from '../_components/user-card/user-card.component';
import { UserSearchDialogComponent } from '../_components/user-search/user-search.component';
import { VideoPlayerPopoverComponent } from '../_components/video-player-popover/video-player-popover.component';
import { LoadingIndicatorComponent } from './loading-indicator/loading-indicator.component';
import { BlockCopyDirective } from '../_helpers/directives/block-copy/block-copy.directive';
import { ConfirmActionDirective } from '../_helpers/directives/confirm-action/confirm-action.directive';
import { ConfirmDangerActionDirective } from '../_helpers/directives/confirm-danger-action/confirm-danger-action.directive';
import { FormErrorsDirective } from '../_helpers/directives/form-errors/form-errors.directive';
import { StylePaginatorDirective } from '../_helpers/directives/style-paginator/style-paginator.directive';
import { CheckIFDate } from '../_helpers/pipes/checkIFDate.pipe';
import { CheckIFDateHour } from '../_helpers/pipes/checkIFDateHour.pipe';
import { CleanNumberPipe } from '../_helpers/pipes/clean-number.pipe';
import { SecondsToHhmmssPipe } from '../_helpers/pipes/seconds-to-hhmmss.pipe';
import { ShortenNamePipe } from '../_helpers/pipes/shortenName';
import { TruncatePipe } from '../_helpers/pipes/truncate.pipe';
import { SecondsToDateTime } from '../_helpers/seconds-to-time.pipe';
import { ChecklistAutomaticEffectiveRulesComponent } from '../_views/first-steps/create-checklist/checklist-automatic-effective-rules/checklist-automatic-effective-rules.component';
import { ChecklistAutomaticItemsChecklistDialogComponent } from '../_views/first-steps/create-checklist/checklist-automatic-items/checklist-automatic-items-checklist/checklist-automatic-items-checklist-dialog.component';
import { ChecklistAutomaticItemsContestationAiComponent } from '../_views/first-steps/create-checklist/checklist-automatic-items/checklist-automatic-items-contestation-ai/checklist-automatic-items-contestation-ai.component';
import { ChecklistAutomaticItemsTypeDialogComponent } from '../_views/first-steps/create-checklist/checklist-automatic-items/checklist-automatic-items-type-dialog/checklist-automatic-items-type-dialog.component';
import { ChecklistAutomaticItemsComponent } from '../_views/first-steps/create-checklist/checklist-automatic-items/checklist-automatic-items.component';
import { ChecklistAutomaticStepThreeComponent } from '../_views/first-steps/create-checklist/checklist-automatic-step-three/checklist-automatic-step-three.component';
import { ChecklistAutomaticStepTwoComponent } from '../_views/first-steps/create-checklist/checklist-automatic-step-two/checklist-automatic-step-two.component';
import { ChecklistManualStepTwoComponent } from '../_views/first-steps/create-checklist/checklist-manual-step-two/checklist-manual-step-two.component';
import { ChecklistMetadataComponent } from '../_views/first-steps/create-checklist/checklist-metadata/checklist-metadata.component';
import { ChecklistMultipleItemsComponent } from '../_views/first-steps/create-checklist/checklist-multiple-items/checklist-multiple-items.component';
import { ChecklistMultipleModalComponent } from '../_views/first-steps/create-checklist/checklist-multiple-items/checklist-multiple-modal/checklist-multiple-modal.component';
import { ChecklistStepOneComponent } from '../_views/first-steps/create-checklist/checklist-step-one/checklist-step-one.component';
import { CreateChecklistComponent } from '../_views/first-steps/create-checklist/create-checklist.component';
import { NewChecklistModalComponent } from '../_views/first-steps/create-checklist/new-checklist-modal/new-checklist-modal.component';
import { ImportDataStepAgentsComponent } from '../_views/first-steps/import-data/import-data-step-agents/import-data-step-agents.component';
import { ImportDataStepFourComponent } from '../_views/first-steps/import-data/import-data-step-four/import-data-step-four.component';
import { ImportDataStepOneComponent } from '../_views/first-steps/import-data/import-data-step-one/import-data-step-one.component';
import { ImportDataStepThreeComponent } from '../_views/first-steps/import-data/import-data-step-three/import-data-step-three.component';
import { ImportDataStepTwoComponent } from '../_views/first-steps/import-data/import-data-step-two/import-data-step-two.component';
import { ImportDataStepZeroComponent } from '../_views/first-steps/import-data/import-data-step-zero/import-data-step-zero.component';
import { ImportDataComponent } from '../_views/first-steps/import-data/import-data.component';
import { InteractionAddComponent } from '../_views/interactions/interaction-add/interaction-add.component';
import { ChangeAnswerButtonComponent } from '../_views/interactions/interaction-contestation/change-answer-button/change-answer-button.component';
import { ContestationAcceptedButtonComponent } from '../_views/interactions/interaction-contestation/contestation-accepted-button/contestation-accepted-button.component';
import { ContestationButtonComponent } from '../_views/interactions/interaction-contestation/contestation-button/contestation-button.component';
import { ContestationDeclinedButtonComponent } from '../_views/interactions/interaction-contestation/contestation-declined-button/contestation-declined-button.component';
import { EditConformingButtonComponent } from '../_views/interactions/interaction-contestation/edit-conforming-button/edit-conforming-button.component';
import { EvaluationDeclineButtonComponent } from '../_views/interactions/interaction-contestation/evaluation-decline-button/evaluation-decline-button.component';
import { FeedbackButtonComponent } from '../_views/interactions/interaction-contestation/feedback-button/feedback-button.component';
import { InteractionContestationButtonDirective } from '../_views/interactions/interaction-contestation/interaction-contestation-button';
import { InteractionContestationComponent } from '../_views/interactions/interaction-contestation/interaction-contestation.component';
import { ReplicaAcceptedButtonComponent } from '../_views/interactions/interaction-contestation/replica-accepted-button/replica-accepted-button.component';
import { ReplicaButtonComponent } from '../_views/interactions/interaction-contestation/replica-button/replica-button.component';
import { ReplicaDeclinedButtonComponent } from '../_views/interactions/interaction-contestation/replica-declined-button/replica-declined-button.component';
import { TreplicaAcceptedButtonComponent } from '../_views/interactions/interaction-contestation/treplica-accepted-button/treplica-accepted-button.component';
import { TreplicaButtonComponent } from '../_views/interactions/interaction-contestation/treplica-button/treplica-button.component';
import { TreplicaDeclinedButtonComponent } from '../_views/interactions/interaction-contestation/treplica-declined-button/treplica-declined-button.component';
import { ConfirmJustificationTypeComponent } from '../_views/interactions/interaction-management/confirm-justification-type.component/confirm-justification-type.component';
import { InteractionsReprocessDialogComponent } from '../_views/interactions/interaction-management/interactions-reprocess-dialog/interactions-reprocess-dialog.component';
import { InteractionSimplifiedComponent } from '../_views/interactions/interaction-simplified/interaction-simplified.component';
import { MonitorInteractionComponent } from '../_views/interactions/monitor-interaction/monitor-interaction.component';
import { PreManualMonitorComponent } from '../_views/interactions/pre-manual-monitor/pre-manual-monitor.component';
import { ReportFiltersComponent } from '../_views/reports/report-filters/report-filters.component';
import { AddTrainingComponent } from '../_views/training/add-training/add-training.component';
import { TrainingListComponent } from '../_views/training/training-list.component';
import { FiltersSidebarComponent } from './components/filters-sidebar/filters-sidebar.component';
import { FeedbackContentComponent } from './components/feedback-content/feedback-content.component';

@NgModule({
  declarations: [
    FiltersSidebarComponent,
    FeedbackContentComponent,
    RangeDatepickerComponent,
    StylePaginatorDirective,
    InteractionModalComponent,
    FilterComponent,
    SelectComponent,
    RangeSliderComponent,
    AgentFilterComponent,
    MonitorFilterComponent,
    CheckIFDate,
    CheckIFDateHour,
    ChecklistStepOneComponent,
    CreateChecklistComponent,
    StepperFooterComponent,
    StandardFooterButtonsComponent,
    ChecklistAutomaticStepTwoComponent,
    ChecklistAutomaticStepThreeComponent,
    ChecklistAutomaticItemsComponent,
    ChecklistAutomaticItemsTypeDialogComponent,
    ChecklistMultipleItemsComponent,
    ChecklistMultipleModalComponent,
    JustificationSelectorModalComponent,
    JustificationInlineFormComponent,
    ChecklistAutomaticEffectiveRulesComponent,
    ChecklistManualStepTwoComponent,
    ChecklistMetadataComponent,
    InlineEditInputComponent,
    LoadingIndicatorComponent,
    CheckableCardComponent,
    SimpleCheckableCardComponent,
    StepperTitleComponent,
    StepperHeaderComponent,
    EvoCardExpandComponent,
    DiasUteisComponent,
    ReportFiltersComponent,
    InteractionAddComponent,
    InteractionContestationComponent,
    MonitorInteractionComponent,
    PreManualMonitorComponent,
    EvoStepperComponent,
    ChecklistItemGroupComponent,
    SearchInputComponent,
    UploadFileComponent,
    StatusBadgeComponent,
    TimelineListComponent,
    ClpAudioPlayerComponent,
    VideoPlayerPopoverComponent,
    InlineVideoPlayerComponent,
    OnboardOverlayComponent,
    StepperModalComponent,
    BarChartWithPaginationComponent,
    BarAndLineChartComponent,
    BarSeriesVerticalComponent,
    CardComponent,
    DataTableComponent,
    InteractionAttachmentDialogComponent,
    InteractionSimplifiedComponent,
    SecondsToDateTime,
    ToastComponent,
    ModalComponent,
    MoreActionsButtonComponent,
    ConfirmDialogComponent,
    RejectAiDecisionModalComponent,
    InputDialogComponent,
    ConfirmDangerDialogComponent,
    HelpDialogComponent,
    GradeComponent,
    TruncatePipe,
    CleanNumberPipe,
    ShortenNamePipe,
    LegendIndicatorComponent,
    IndicatorsComponent,
    AvatarInitialsComponent,
    ConfirmMonitorComponent,
    FormErrorsDirective,
    ItemCheckComponent,
    ConfirmDangerActionDirective,
    BlockCopyDirective,
    UserCardComponent,
    NewChecklistModalComponent,
    OnlyPremiumDialogComponent,
    UserSearchDialogComponent,
    InteractionContestationButtonDirective,
    CurrentStepDirective,
    TrainingErrorDialogComponent,
    TrainingListComponent,
    AddTrainingComponent,
    EvoDndDirective,
    SpeedTestComponent,
    AiChatComponent,
    AiChatFiltersComponent,
    ChecklistAutomaticItemsContestationAiComponent,
    ChecklistAutomaticItemsChecklistDialogComponent,
    ChecklistItemsModalComponent,
    ChecklistItemHistoriesComponent,
    ContestationAiPreviewModalComponent,

    /** Import Data **/
    ImportDataComponent,
    ImportDataStepZeroComponent,
    ImportDataStepOneComponent,
    ImportDataStepTwoComponent,
    ImportDataStepThreeComponent,
    ImportDataStepFourComponent,
    ImportDataStepAgentsComponent,

    /** Interaction Components */
    ChangeAnswerButtonComponent,
    ContestationAcceptedButtonComponent,
    ContestationButtonComponent,
    ContestationDeclinedButtonComponent,
    EvaluationDeclineButtonComponent,
    FeedbackButtonComponent,
    ReplicaAcceptedButtonComponent,
    ReplicaButtonComponent,
    ReplicaDeclinedButtonComponent,
    TreplicaAcceptedButtonComponent,
    TreplicaButtonComponent,
    TreplicaDeclinedButtonComponent,
    ConfirmJustificationTypeComponent,
    EditConformingButtonComponent,

    /** Pipes **/
    TimeFormatPipe,
    ConfirmActionDirective,
    SecondsToHhmmssPipe,

    /** Dialogs **/
    OperationAddDialogComponent,
    InteractionsReprocessDialogComponent,

    /** Comment Components **/
    InteractionCommentsComponent,
    InteractionCommentModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxChartsModule,
    NgSelectModule,
    NgbModule,
    NgxSliderModule,
    NgxDatatableModule,
    DataTablesModule,
    TagCloudModule,

    /** Angular Material **/
    MatSortModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    DragDropModule,
    MatTabsModule,
    MatSliderModule,

    /** Bootstrap and other modules **/
    BsDropdownModule,
    CollapseModule,
    TooltipModule,
    MarkdownModule.forChild(),
    NgxPermissionsModule.forChild(),
  ],
  exports: [
    FiltersSidebarComponent,
    FeedbackContentComponent,
    RangeDatepickerComponent,
    StylePaginatorDirective,
    InteractionModalComponent,
    FilterComponent,
    SelectComponent,
    RangeSliderComponent,
    AgentFilterComponent,
    MonitorFilterComponent,
    CheckIFDate,
    CheckIFDateHour,
    CreateChecklistComponent,
    StepperFooterComponent,
    StandardFooterButtonsComponent,
    ChecklistStepOneComponent,
    ChecklistAutomaticStepTwoComponent,
    ChecklistAutomaticStepThreeComponent,
    ChecklistAutomaticItemsComponent,
    ChecklistAutomaticItemsTypeDialogComponent,
    ChecklistMultipleItemsComponent,
    ChecklistMultipleModalComponent,
    JustificationSelectorModalComponent,
    JustificationInlineFormComponent,
    ChecklistAutomaticEffectiveRulesComponent,
    ChecklistManualStepTwoComponent,
    ChecklistMetadataComponent,
    InlineEditInputComponent,
    LoadingIndicatorComponent,
    CheckableCardComponent,
    SimpleCheckableCardComponent,
    StepperTitleComponent,
    StepperHeaderComponent,
    EvoCardExpandComponent,
    DiasUteisComponent,
    ReportFiltersComponent,
    InteractionAddComponent,
    InteractionContestationComponent,
    MonitorInteractionComponent,
    PreManualMonitorComponent,
    EvoStepperComponent,
    ChecklistItemGroupComponent,
    SearchInputComponent,
    UploadFileComponent,
    StatusBadgeComponent,
    TimelineListComponent,
    ClpAudioPlayerComponent,
    InlineVideoPlayerComponent,
    OnboardOverlayComponent,
    StepperModalComponent,
    BarChartWithPaginationComponent,
    BarAndLineChartComponent,
    BarSeriesVerticalComponent,
    CardComponent,
    DataTableComponent,
    InteractionAttachmentDialogComponent,
    InteractionsReprocessDialogComponent,
    SecondsToDateTime,
    ToastComponent,
    ModalComponent,
    ConfirmDialogComponent,
    RejectAiDecisionModalComponent,
    InputDialogComponent,
    ConfirmDangerDialogComponent,
    HelpDialogComponent,
    GradeComponent,
    LegendIndicatorComponent,
    IndicatorsComponent,
    AvatarInitialsComponent,
    ConfirmMonitorComponent,
    FormErrorsDirective,
    ItemCheckComponent,
    ConfirmDangerActionDirective,
    BlockCopyDirective,
    UserCardComponent,
    NewChecklistModalComponent,
    OnlyPremiumDialogComponent,
    UserSearchDialogComponent,
    InteractionContestationButtonDirective,
    CurrentStepDirective,
    TrainingErrorDialogComponent,
    TrainingListComponent,
    AddTrainingComponent,
    EvoDndDirective,
    SpeedTestComponent,
    AiChatComponent,
    AiChatFiltersComponent,
    ChecklistAutomaticItemsContestationAiComponent,
    ChecklistAutomaticItemsChecklistDialogComponent,
    ChecklistItemsModalComponent,
    ChecklistItemHistoriesComponent,
    ContestationAiPreviewModalComponent,
    ConfirmJustificationTypeComponent,
    InteractionSimplifiedComponent,
    VideoPlayerPopoverComponent,
    MoreActionsButtonComponent,

    /** Interaction Components */
    ChangeAnswerButtonComponent,
    ContestationAcceptedButtonComponent,
    ContestationButtonComponent,
    ContestationDeclinedButtonComponent,
    EvaluationDeclineButtonComponent,
    FeedbackButtonComponent,
    ReplicaAcceptedButtonComponent,
    ReplicaButtonComponent,
    ReplicaDeclinedButtonComponent,
    TreplicaAcceptedButtonComponent,
    TreplicaButtonComponent,
    TreplicaDeclinedButtonComponent,
    EditConformingButtonComponent,

    /** Pipes **/
    CleanNumberPipe,
    TruncatePipe,
    TimeFormatPipe,
    TitleCasePipe,
    ConfirmActionDirective,
    ShortenNamePipe,
    SecondsToHhmmssPipe,

    /** Dialogs **/
    OperationAddDialogComponent,
    InteractionsReprocessDialogComponent,

    /** Comment Components **/
    InteractionCommentsComponent,
    InteractionCommentModalComponent,

    /** Modules **/
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxChartsModule,
    NgSelectModule,
    NgbModule,
    NgxSliderModule,
    NgxDatatableModule,
    DataTablesModule,
    TagCloudModule,

    /** Angular Material **/
    MatSortModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    DragDropModule,
    MatTabsModule,
    MatSliderModule,

    /** Bootstrap and other modules **/
    BsDropdownModule,
    CollapseModule,
    TooltipModule,
    MarkdownModule,
    NgxPermissionsModule,
  ],
})
export class SharedModule {}
